import Swiper from "swiper";
import {Navigation, Scrollbar} from "swiper/modules";
import './content-elements/card-steps';
import {
    Dropdown,
    initTWE,
} from "tw-elements";

initTWE({ Dropdown});

new Swiper('.contentElementSwiper', {
    spaceBetween: 20,
    slidesPerView: 1.5,
    freeMode: true,
    breakpoints: {
        768: {
            slidesPerView: 4,

        },
    },
});
new Swiper('.productCategoryHomepageSwiper', {
    modules: [Navigation, Scrollbar],
    watchOverflow: true,
    spaceBetween: 20,
    slidesPerView: 1.33,
    breakpoints: {
        768: {
            slidesPerView: 4,
        },
    },
    navigation: {
        nextEl: ".productCategoryHomepageSwiper-button-next",
        prevEl: ".productCategoryHomepageSwiper-button-prev",
    },
    scrollbar: {
        el: '.productCategoryHomepageSwiper-scrollbar',
        draggable: true,
    },
});


new Swiper('.collaborationsSwiper', {
    slidesPerView: 1.5,
    // spaceBetween: 20,
    loop: false,
    breakpoints: {
        768: {
            slidesPerView: 5,
        },
    },
});


new Swiper('.productCategorySwiper', {
    spaceBetween: 20,
    slidesPerView: 1.33,
    freeMode: true,
    resizeObserver: false,
    breakpoints: {
        768: {
            slidesPerView: 4,
        },
    },
});

new Swiper('.handPickedProductsSlider', {
    modules: [Navigation],
    slidesPerView: 1.33,
    spaceBetween: 20,
    resizeObserver: false,
    navigation: {
        nextEl: '.handPickedProductsSlider .handPickedProducts-button-next',
        prevEl: '.handPickedProductsSlider .handPickedProducts-button-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 4,
        },
    },
});

jQuery(document).ready(function ($) {
    $('.btn-product-position button').on('click', function (e) {
        e.preventDefault();

        var button = $(this);
        var postId = button.attr('id');
        var targetCard = $("div[aria-labelledby='" + postId + "']");
        var parent = button.closest('.btn-product-position');

        // Hide all other cards
        $("div[aria-labelledby]").not(targetCard).addClass('hidden');
        $('.btn-product-position').not(parent).removeClass('btn-product-pos-active');

        // Toggle current card visibility
        targetCard.toggleClass('hidden');

        // Toggle btn-product-pos-active class on the container
        if (targetCard.hasClass('hidden')) {
            parent.removeClass('btn-product-pos-active');
        } else {
            parent.addClass('btn-product-pos-active');
        }
    });

    $(document).on('click', function (e) {
        if (
            !$(e.target).closest('.btn-product-position, [aria-labelledby]').length
        ) {
            $("div[aria-labelledby]").addClass('hidden');
            $('.btn-product-position').removeClass('btn-product-pos-active');
        }
    });
});